// userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loggedIn: false,
  userDetail: {
    id: "",
    username: '',
  },
  decimalPlacesForAmountFormatting: null,
  UserCompleteDetails: {}
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoggedIn: (state, action) => {
      state.loggedIn = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetail = action.payload;
    },
    setDecimalPlaces: (state, action) => {
      state.decimalPlacesForAmountFormatting = action.payload;
    },
    logout: (state) => {
      state.loggedIn = false;
      state.userDetail = null;
      state.decimalPlacesForAmountFormatting = null
    },
     setUserCompleteDetails: (state, action) => {
      state.UserCompleteDetails = action.payload;
    },
  },
});

export const { setLoggedIn, setUserDetails, logout, setDecimalPlaces,setUserCompleteDetails } = userSlice.actions;
export default userSlice.reducer;


